var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResourceProfiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 300",
    style: {
      enableBackground: "new 0 0 405.4 265.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5",
    gradientUnits: "userSpaceOnUse",
    x1: 79.8,
    y1: 786.5656,
    x2: 368.2,
    y2: 786.5656,
    gradientTransform: "matrix(1 0 0 1 0 -650.1656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5)"
    },
    d: "M357.5,34.2h-267c-5.9,0-10.7,4.8-10.7,10.7v183c0,5.9,4.8,10.7,10.7,10.7h272 c3.1,0,5.7-2.5,5.7-5.7V44.8C368.1,39,363.4,34.2,357.5,34.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "353.2,62.3 94.7,62.3 94.7,62.3 94.7,49.5 353.2,49.5 353.2,49.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M94.7,71.6v150.2c0,1.6,1.3,3,3,3h252.5c1.6,0,3-1.3,3-3V73c0-0.7-0.6-1.3-1.3-1.3L94.7,71.6 L94.7,71.6L94.7,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494948"
    },
    d: "M347.3,55.9c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S347.3,54.2,347.3,55.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043428643559993830320000002756710159792007814_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.2,
    y1: 897.2156,
    x2: 385,
    y2: 897.2156,
    gradientTransform: "matrix(1 0 0 1 0 -650.1656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043428643559993830320000002756710159792007814_)"
    },
    d: "M379.3,238.6H71c-3.2,0-5.8,2.5-5.8,5.7 v1.3c0,5.5,4.5,9.9,10.1,9.9l303.2-0.7c5.6,0,6.5-3.8,6.5-9.2v-1.3C385,241.1,382.5,238.6,379.3,238.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157995602966138086670000008596427641713965722_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.3,
    y1: -231.2244,
    x2: 395.9,
    y2: -159.6244,
    gradientTransform: "matrix(1 0 0 -1 0 -32.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 353.2,
    y: 98,
    style: {
      fill: "url(#SVGID_00000157995602966138086670000008596427641713965722_)"
    },
    width: 13.8,
    height: 129.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M381.4,66.7c0,1.8-1.5,3-3,3v-3H381.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68382D"
    },
    d: "M65.6,100.4c-4,14.1-21.5,23.3-35.4,20.8c-8.8-1.6-16.5-7.9-15.7-10.3c0.7-2.3,8.9-0.9,9.5-3.4 c0.4-1.6-2.6-4.4-5.8-5.1c-3.6-0.8-6.1,1.3-8.3-0.5c-0.1-0.1-1.2-1-1.2-2.2c0.1-1.3,1.7-2.3,2.9-2.6c4.5-1.2,7.9,7.2,12.2,6.2 c2.7-0.6,4.6-4.8,3.7-6.2c-0.7-1.1-3.3-0.2-4.1-1.6c-0.3-0.6-0.3-1.3,0-1.8c0.6-0.9,2-1,2.9-0.8c1.3,0.3,1.6,1.4,2.8,2.2 c1.7,1.2,3.8,1,5.2,0.8c6.4-0.8,7.4-14.4,16-17.2c4.2-1.4,9-0.2,12,2.3C69.2,87.1,65.9,99.6,65.6,100.4L65.6,100.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088105854635765589640000011356854727008386238_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.39,
    y1: -154.6055,
    x2: 81.01,
    y2: -154.6055,
    gradientTransform: "matrix(1 0 0 -1 0 -32.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C06C84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#A36681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#8C6180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#7F5E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A5D7E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088105854635765589640000011356854727008386238_)"
    },
    d: "M80.7,97.3c-3.4-0.4-7.4-0.4-11.5,0.6 c-2.5,0.6-4.7,1.5-4.7,1.5c-1.7,0.8-3.2,1.5-3.2,1.5c-0.3,0.6-1,2-2.7,3c-1.3,0.8-2.5,1-3.2,1.1c-1,0.5-2.7,1.5-3.5,3.4 c-0.6,1.4-0.5,2.6-0.4,3.4c1.1,8.9,7.8,11.6,7.8,11.6c5.8,9.3,19.7,26.8,20.5,22.7C81.8,136.2,80.7,97.3,80.7,97.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024681740534695726050000009722133029776370845_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.2897,
    y1: 795.2756,
    x2: 75.1797,
    y2: 814.6556,
    gradientTransform: "matrix(1 0 0 1 0 -650.7856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024681740534695726050000009722133029776370845_)"
    },
    d: "M71.7,139.1c-2,12.6,9,31,9,31l0.2-38.1 L71.7,139.1L71.7,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M53.5,96.9c0.7,2.5,1.4,5.1,2.1,7.6c0.8,0,2.6-0.2,4.3-1.5c1-0.8,1.6-1.6,2-2.2 c-0.8-2-1.6-4-2.4-6.1H53C53.2,95.4,53.3,96.1,53.5,96.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F68D61"
    },
    d: "M59.7,95.1l-1.3-0.4h-0.6l-2,1.2l-0.1,1.7c0.2,0.3,1.1,1.6,2.8,2.1c1.2,0.3,2.3,0.2,3.1-0.1 C60.8,98.1,60.2,96.6,59.7,95.1C59.7,95.1,59.7,95.1,59.7,95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M59.9,83.3c0.5,1.1,1.4,3.6,1.6,4.2c0.2,0.8,0.4,1.1,0.6,1.9c0.8,2.7,1,2.7,1.3,4 c0.5,2.1,0.8,3.2,0.2,4.1c-0.7,0.9-2,1-4,1.1c-1.4,0.1-2.4,0.1-3.6-0.5c-1.3-0.7-2-1.8-2.3-2.3c0,0-0.1,0.8-0.7,0.5 c-0.6-0.3-2.8-3.2-1.7-3.7c1.1-0.6,2.1,0.9,2.1,0.9l0.6-1C54.2,92.4,53.6,79.9,59.9,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M61.3,93.8c0.4,1,1.5,1.5,2.5,1.1c0-0.2-0.1-0.4-0.1-0.6c-0.1-0.4-0.2-0.9-0.3-1.4L61.3,93.8 C61.3,93.8,61.3,93.8,61.3,93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M79.3,97.2h3.6c0.4,0,0.8-0.4,0.7-0.8c0-0.3-0.4-0.6-0.7-0.6l-3.6-0.4 C78.5,96.4,79.3,97.2,79.3,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M79,98.9c1.2,0.1,2.3,0.1,3.4,0.2c0.5,0.1,0.9-0.3,0.9-0.7c0-0.3-0.2-0.6-0.6-0.7 c-1.2-0.2-2.3-0.3-3.5-0.5C78.4,98,79.1,98.9,79,98.9C79,98.9,79,98.9,79,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M78.8,100.4c1,0.1,2,0.2,3.2,0.2c0.3-0.1,0.5-0.3,0.6-0.6c0.1-0.3-0.1-0.6-0.3-0.7L79,98.9 C78.5,99.4,78.6,100,78.8,100.4C78.8,100.4,78.8,100.4,78.8,100.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M79.3,95.4l3.7-0.2c0.4,0,0.6-0.3,0.6-0.7s-0.3-0.7-0.7-0.7c-1.2,0-2.4-0.1-3.6-0.1 C78.7,94.7,79.3,95.4,79.3,95.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M81.8,140.2c-0.1-0.1-1.5-1-2.7-0.4c-0.3,0.2-0.6,0.4-0.7,0.6l-1.2-0.2l-1.1,4.9 c0.5-0.1,1-0.2,1.5-0.2c0,0.3,0.1,0.5,0.2,0.7c0.6,1,2.5,1.1,4.9,0.5C82.5,144,82.2,142.1,81.8,140.2L81.8,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F68D61"
    },
    d: "M81.8,140.2c-0.1-0.1-1.5-1-2.7-0.4l0,0c-0.1,0.8,0,1.2,0,1.2s-0.5,0.9,0.1,1.6c0,0-0.8,1.1-0.1,2.2 c0,0-0.3,0.8-0.2,1.4c0.9,0.3,2.3,0.2,3.9-0.2C82.5,144,82.2,142.1,81.8,140.2C81.8,140.2,81.8,140.2,81.8,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M80.4,143.3l4.3-0.3c0.5-0.1,0.9-0.6,0.8-1s-0.5-0.7-1-0.7l-4.4-0.1 C79.2,142.5,80.3,143.3,80.4,143.3C80.4,143.3,80.4,143.3,80.4,143.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M80.2,145.4c1.4,0,2.8-0.1,4.1-0.1c0.6,0,1-0.4,1-0.9c0-0.4-0.3-0.7-0.8-0.8l-4.2-0.3 C79.3,144.3,80.2,145.4,80.2,145.4L80.2,145.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M80,147.2h3.9c0.3-0.1,0.6-0.4,0.6-0.7s-0.1-0.7-0.4-0.8c-1.3-0.1-2.6-0.1-3.9-0.2 C79.6,146.1,79.8,146.8,80,147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M80.2,141.2c1.5-0.2,2.9-0.4,4.3-0.6c0.4-0.1,0.7-0.5,0.7-0.9c0-0.5-0.4-0.8-0.9-0.8 c-1.5,0.1-2.9,0.2-4.3,0.2C79.4,140.4,80.2,141.2,80.2,141.2C80.2,141.2,80.2,141.2,80.2,141.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109737667667601302680000003300684524094268858_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.1559,
    y1: -158.7139,
    x2: 77.6,
    y2: -158.7139,
    gradientTransform: "matrix(1 0 0 -1 0 -32.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C06C84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#A36681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#8C6180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#7F5E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A5D7E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109737667667601302680000003300684524094268858_)"
    },
    d: "M58.2,144.4c-5.9-3-8.6-8.3-9.5-11.2 c-2.7-8-1.6-20.1,1.3-24.1c1.5-2.1,3-3,4.3-3.8c-0.4,2.4,0.3,5.9,0.9,9.9c0.8,6.2,2.2,1.7,3.9,4.2c0.3,1.7,2,13.2,4,15.1 c1.9,1.8,12.9,4.2,14.5,4.5v7.5C75.3,147,62.4,146.5,58.2,144.4C58.2,144.4,58.2,144.4,58.2,144.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2E5EA0"
    },
    cx: 223.4,
    cy: 87.3,
    r: 64.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M206.1,99.7c-5.3-4.8-8.6-11.7-8.6-19.5c0.1-14.3,11.8-25.9,26.2-25.9c14.3,0.1,25.9,11.8,25.9,26.2 c0,7.7-3.5,14.6-8.9,19.4c12.9,6.4,21.6,19.8,21.5,35.1c0,1.3-0.1,2.8-0.3,4.1c-10.9,8.1-24.3,12.8-38.8,12.8 c-14.5-0.1-27.9-4.9-38.6-13.1c-0.1-1.3-0.3-2.8-0.1-4.1C184.3,119.2,193.2,106,206.1,99.7L206.1,99.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191519"
    },
    d: "M215.9,210.6l-0.6-58l3.8-0.2l0.6,58c-0.2,0.9-0.6,1.8-1.5,1.8h-0.5 C216.8,212.1,215.9,211.5,215.9,210.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312B30"
    },
    d: "M173.8,215.3l-0.8-62.4l3.8-0.2l0.8,62.4c-0.2,0.9-0.6,1.8-1.5,1.8l-0.9-0.2 C174.2,217.3,173.3,216.4,173.8,215.3L173.8,215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191519"
    },
    d: "M165.9,212.9l-0.6-58l4.4-0.2l0.6,58c-0.2,0.9-0.6,1.8-1.5,1.8h-0.5 C167.3,214.4,165.8,213.8,165.9,212.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191519"
    },
    d: "M164.3,155.7l-0.2-16.3c0-0.5,0.5-0.5,0.6-0.9l61-0.9c0.5,0,0.5,0.5,0.9,0.6l0.2,16.3 c0,0.5-0.5,0.5-0.6,0.9l-61.5,0.9C164.7,156.1,164.1,156.1,164.3,155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191519"
    },
    d: "M231.3,209.4c-2.3-2.6-2.9-6-2.1-9.2l6-27.3l2,0.2l-6,27.3c-0.8,2.9,0,5.3,1.8,7.9 c2.3,2.1,4.5,3.2,7.4,3l31.1-0.5c2.9-0.3,5.4-1.5,6.9-3.8c2.1-2.3,2.3-5.1,1.7-8l-6.8-22.6l1.5-0.3l6.8,23.1c0.8,2.9,0,6.6-1.7,9.5 c-2.1,2.7-5.1,4.4-8.5,4.5l-31.1-0.2C236.8,213.2,234,211.5,231.3,209.4L231.3,209.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAA5AA"
    },
    d: "M281.8,124.7c-2.1,2.3-6.2,5.3-8.6,11.3c-4.7,11.2-0.8,21.4,0.5,23.6l5.3,5.3l8.9-39.6 C285.1,125,283.1,125.3,281.8,124.7L281.8,124.7z M234.8,167c-3.6,3.5,0,6.6,0,6.6l39.9-0.6l-0.3-8.2 C274.2,164.9,238.3,164.4,234.8,167z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018195031740523971180000006279659517337971591_",
    gradientUnits: "userSpaceOnUse",
    x1: -5369.3462,
    y1: -722.8195,
    x2: -5351.0981,
    y2: -722.8195,
    gradientTransform: "matrix(-0.9999 1.483486e-02 -1.483486e-02 -0.9999 -5101.1616 -477.1429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018195031740523971180000006279659517337971591_)"
    },
    d: "M261.5,173.5l-0.2,1.4 c4.7,1.4,9.4,2.1,14.2,3c1.4-4.2,2.6-8.9,3.9-13.1l-7.2-10.6c-1.1,0.5-1.5,0.9-2.6,1.2c1.2,3.5,2.9,6.5,5,9.5 c-0.8,2.9-1.4,5.6-2.1,8.5l-9.7,0.2L261.5,173.5L261.5,173.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168095667808841593040000005109231184135383998_",
    gradientUnits: "userSpaceOnUse",
    x1: -5361.9565,
    y1: -718.0629,
    x2: -5326.0063,
    y2: -718.0629,
    gradientTransform: "matrix(-0.9999 1.483486e-02 -1.483486e-02 -0.9999 -5101.1616 -477.1429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168095667808841593040000005109231184135383998_)"
    },
    d: "M236.2,155.2c-0.5-1.1-0.3-2.4-0.2-3.3 c0.6-1.8,1.7-3.2,2.1-3.2c1.5-0.9,3-1.2,3.5-1.2c1.4,0.2,11.5,0.5,16.2,0.8c2,0.2,2.9,0.3,3.8,0.3c3.3-0.2,5.1,1.4,5.1,1.4l4.8,4.7 l-1.1,1.4l-4.8-5.1c0,0-1.4-1.1-3.8-0.8c-0.5-0.5-2-0.2-3.8-0.3c-2-0.2-4.8-0.5-10.6-0.3c-2-0.2-3.8-0.3-6.2-0.5 c-0.5,0-2,0.8-3,2.1c-0.6,0.9-1.2,2.3-0.8,3.8l9.4,19.9c0,0,0,0.5-0.6,0.9c-0.5,0.5-0.9-0.2-0.9-0.2L236.2,155.2L236.2,155.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAA5AA"
    },
    d: "M224.7,137.5c0.9,0.2,2-0.8,2.1-2.3c0.2-0.9-0.8-2-2.3-2.1l-24.5,0.5l-4.8-23.9 c-0.3-1.5-1.2-2-2.3-1.7c-1.5,0.3-2,1.2-1.7,2.3l5.1,25.4c-0.2,0.9,0.9,1.5,1.8,1.5L224.7,137.5L224.7,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312B30"
    },
    d: "M222.7,215l-0.8-62.4l3.8-0.2l0.8,62.4c-0.2,0.9-0.6,1.8-1.5,1.8h-0.5 C223.6,216.5,223.2,215.9,222.7,215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312B30"
    },
    d: "M169.1,155.5l-0.2-16.8c0-0.5,0.5-0.5,0.6-0.9l61.5-0.9c0.5,0,0.5,0.5,0.9,0.6l0.2,16.8 c0,0.5-0.5,0.5-0.6,0.9l-61.9,0.8C169.2,156,169,155.9,169.1,155.5L169.1,155.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 163.5,
    y: 137.6,
    style: {
      fill: "#ED5233"
    },
    width: 24.5,
    height: 24.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 145.7,
    transform: "matrix(0.6563 -0.7545 0.7545 0.6563 -54.0329 179.4822)",
    style: {
      fill: "#FFFFFF"
    },
    width: 1.1,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.7,
    y: 148.4,
    transform: "matrix(0.659 -0.7522 0.7522 0.659 -53.9976 178.7253)",
    style: {
      fill: "#FFFFFF"
    },
    width: 6.8,
    height: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 174.7,
    cy: 154.5,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 178.7,
    cy: 154.5,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 182.6,
    cy: 154.5,
    r: 1.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceProfiles);
export default __webpack_public_path__ + "static/media/resourceProfiles.a3cf20ee.svg";
export { ForwardRef as ReactComponent };